import React from "react";
import { Lock } from "lucide-react";
import { useBuilder, BlockConfig } from "../BuilderContext";

const fmt = (cents: number) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(cents / 100);

const TotalsSummaryBlock: React.FC<{ block: BlockConfig }> = ({ block }) => {
  const { state } = useBuilder();
  const heading = block.settings.headingOverride || "Summary";
  const t = state.totals;

  return (
    <div className="py-4">
      <div className="flex items-center gap-2 mb-3">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide">{heading}</p>
        <Lock className="h-3 w-3 text-slate-300 print:hidden" />
      </div>
      <div className="ml-auto max-w-xs space-y-1.5">
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">Subtotal</span>
          <span className="text-slate-800">{fmt(t.subtotalCents)}</span>
        </div>
        {t.discountCents > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Discount</span>
            <span className="text-red-600">-{fmt(t.discountCents)}</span>
          </div>
        )}
        {t.taxCents > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Tax</span>
            <span className="text-slate-800">{fmt(t.taxCents)}</span>
          </div>
        )}
        <div className="flex justify-between text-sm font-bold border-t pt-1.5" style={{ borderColor: "var(--color-primary)" }}>
          <span className="text-slate-800">Total</span>
          <span className="text-slate-800">{fmt(t.totalCents)}</span>
        </div>
        {t.paidCents > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Paid</span>
            <span className="text-emerald-600">-{fmt(t.paidCents)}</span>
          </div>
        )}
        <div className="flex justify-between text-base font-bold pt-1">
          <span style={{ color: "var(--color-primary)" }}>Balance Due</span>
          <span style={{ color: "var(--color-primary)" }}>{fmt(t.balanceDueCents)}</span>
        </div>
      </div>
    </div>
  );
};

export default TotalsSummaryBlock;
